export enum CompanyNames {
	LORI = 'LORI',
	IMPERIAL = 'IMPERIAL',
}
